import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const consultationsServices = [
  {
    serviceId: 'CONS_001',
    serviceName: 'General Practice Consultation',
    category: 'Consultations',
    specialty: null,
    subCategory: 'General Medicine',
    description: 'Comprehensive general medical consultation for routine health concerns',
    cost: 450,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'GP001',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['general', 'consultation', 'routine'],
    displayOrder: 1
  },
  {
    serviceId: 'CONS_002',
    serviceName: 'Specialist Consultation',
    category: 'Consultations',
    specialty: 'Various',
    subCategory: 'Specialist Care',
    description: 'Consultation with medical specialist for focused assessment',
    cost: 850,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.SPECIALIST,
    status: 'active',
    billingCode: 'SPEC001',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['specialist', 'consultation', 'focused'],
    displayOrder: 2
  },
  {
    serviceId: 'CONS_003',
    serviceName: 'Telehealth Consultation',
    category: 'Consultations',
    specialty: null,
    subCategory: 'Virtual Care',
    description: 'Remote medical consultation via video call or phone',
    cost: 350,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'TELE001',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['telehealth', 'virtual', 'remote'],
    displayOrder: 3
  },
  {
    serviceId: 'CONS_004',
    serviceName: 'Chronic Disease Management',
    category: 'Consultations',
    specialty: null,
    subCategory: 'Chronic Care',
    description: 'Ongoing management consultation for chronic conditions',
    cost: 400,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'CHRON001',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['chronic', 'management', 'ongoing'],
    displayOrder: 4
  },
  {
    serviceId: 'CONS_005',
    serviceName: 'Follow-up Consultation',
    category: 'Consultations',
    specialty: null,
    subCategory: 'Follow-up Care',
    description: 'Follow-up visit for ongoing treatment or post-procedure care',
    cost: 300,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'FOLL001',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['follow-up', 'continuing', 'care'],
    displayOrder: 5
  },
  {
    serviceId: 'CONS_006',
    serviceName: 'Emergency Consultation',
    category: 'Consultations',
    specialty: null,
    subCategory: 'Urgent Care',
    description: 'Urgent medical consultation for acute conditions',
    cost: 650,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'EMERG001',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['emergency', 'urgent', 'acute'],
    displayOrder: 6
  }
]

export default consultationsServices
